var parse = require('url-parse');
import moment from "moment"

Array.prototype.shuffle = function () {
  var counter = this.length,
    temp, index;

  // While there are elements in the array
  while (counter > 0) {
    // Pick a random index
    index = (Math.random() * counter--) | 0;

    // And swap the last element with it
    temp = this[counter];
    this[counter] = this[index];
    this[index] = temp;
  }
  return this
};

export default {
  date: function (d) {
    if (!d) {
      return null
    }
    return moment(d).format('MMMM Do YYYY')
  },
  fromNow: function (d) {
    if (!d) {
      return 'Never'
    }
    return moment(d).fromNow()
  },
  rules: {
    check: v => {
      if (v) {
        return true
      } else {
        return "Required"
      }
    },
    fullName: v => !v ? "Required" : v.split(" ").length > 1 || "Full Name Required",
    phone: v => v.length >= 14 || "Invalid",
    code: v => v.length === 4 || "Invalid",
    name: v => v.split(" ").length > 1 || "Full name required",
    agree: v => !!v || 'Required',
    email: value => {
      if (!value) {
        return true
      }
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'Invalid e-mail.'
    },
    password: value => {

      let uppercase = new RegExp("[A-Z]")
      let digit = new RegExp("[0-9]")

      if (uppercase.test(value) && digit.test(value)) {
        return true
      } else {
        return 'Password must contain at least one number and a capital letter.'
      }
    },
    required: value => !!value || 'Required',
    min: v => v.length >= 8 || 'Min 8 characters',
    url: v => v.startsWith("http") && v.includes(".") || "Invalid link"
  },
  validEmail: function (e) {
    if (!e) {
      return false
    }
    //TODO: Improve this or use a library
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(e)
  },
  youtubeId: function (url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length == 11) ? match[7] : false;
  },
  vimeoId: function (url) {
    let parsed = parse(url)
    console.log("vimeoId parsed", parsed)
    return (parsed.pathname.split("/")[parsed.pathname.split("/").length - 1])
  },
  iframeFromUrl: function (u) {
    try {
      let parsed = parse(u)
      if (parsed.query.startsWith("?")) {
        parsed.query = parsed.query.substr(1);
      }
      parsed.path = parsed.pathname

      let youtube = `https://www.youtube.com/embed/`
      let vimeo = `https://player.vimeo.com/video/`

      if (parsed.hostname === "www.youtube.com") {
        if (parsed.query) {
          let fields = parsed.query.split("&")
          let query = {}
          fields.forEach(f => {
            query[f.split("=")[0]] = f.split("=")[1]
          })
          return query.v ? (youtube + query.v) : u
        }
        return youtube + parsed.path.split("/")[parsed.path.split("/").length - 1]

      }
      if (parsed.hostname === "youtu.be") {
        return youtube + (parsed.path.split("/")[parsed.path.split("/").length - 1])
      }
      if (parsed.hostname === "player.vimeo.com") {
        return vimeo + (parsed.path.split("/")[parsed.path.split("/").length - 1])
      }
      if (parsed.hostname === "vimeo.com") {
        return vimeo + (parsed.path.split("/")[parsed.path.split("/").length - 1])
      }
    } catch (ex) {
      alert(`"idFromUrl verror" ${ex}`)
    }
    return u
  },
  linkColor(link) {
    if (!link) {
      return "primary"
    }
    if (link.includes('pinterest')) {
      return "#c81a22"
    }
    if (link.includes("snapchat")) {
      return "#fffc00"
    }
    if (link.includes('facebook')) {
      return "#4267b2"
    }
    if (link.includes('google')) {
      return "#dd4b39"
    }

    if (link.includes('linkedin')) {
      return "#283e4a"
    }
    if (link.includes('twitter')) {
      return "#1da1f2"
    }
    if (link.includes('youtube')) {
      return "#f00"
    }
    if (link.includes('youtu.be')) {
      return "#f00"
    }
    if (link.includes('instagram')) {
      return "#262626"
    }
    if (link.includes("soundcloud")) {
      return "#f16a23"
    }
    if (link.includes("tumblr")) {
      return "#000"
    }
    if (link.includes("hitrecord")) {
      return "#fe0708"
    }
    if (link.includes("tiktok")) {
      return "#25f4ee"
    }
    return 'primary'
  },
  linkIcon(link) {
    if (!link) {
      return "fa-share"
    }
    if (link.includes('snapchat')) {
      return "fab fa-snapchat"
    }
    if (link.includes('pinterest')) {
      return "fab fa-pinterest"
    }
    if (link.includes('facebook')) {
      return "fab fa-facebook"
    }
    if (link.includes('google')) {
      return "fab fa-google"
    }
    if (link.includes('linkedin')) {
      return "fab fa-linkedin"
    }
    if (link.includes('twitter')) {
      return "fab fa-twitter"
    }
    if (link.includes('youtube')) {
      return "fab fa-youtube"
    }
    if (link.includes('youtu.be')) {
      return "fab fa-youtube"
    }
    if (link.includes('instagram')) {
      return "fab fa-instagram"
    }
    if (link.includes('soundcloud')) {
      return "fab fa-soundcloud"
    }
    if (link.includes("tumblr")) {
      return "fab fa-tumblr"
    }
    if (link.includes("hitrecord")) {
      return "fas fa-record-vinyl"
    }
    if (link.includes("tiktok")) {
      return "fas fa-video"
    }
    return 'fa-link'
  }
}